

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const DOWNLOADKRAKPIANSWERSOFMANAGERANDREVIEWEREVALUTATIONSAMPLEEXCELFILE= createAsyncThunk(
  "downloadKraKpiAnswersOfManagerAndReviewerEvalutationSampleExcelFile/downloadKraKpiAnswersOfManagerAndReviewerEvalutationSampleExcelFile",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const downloadKraKpiAnswersOfManagerAndReviewerEvalutationSampleExcelFileSlice = createSlice({
  name: "downloadKraKpiAnswersOfManagerAndReviewerEvalutationSampleExcelFileSlice",
  initialState: {
    downloadKraKpiAnswersOfManagerAndReviewerEvalutationSampleExcelFile: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfdownloadKraKpiAnswersOfManagerAndReviewerEvalutationSampleExcelFile: (state) => {
        state.downloadKraKpiAnswersOfManagerAndReviewerEvalutationSampleExcelFile.loading = false
        state.downloadKraKpiAnswersOfManagerAndReviewerEvalutationSampleExcelFile.error = false
        state.downloadKraKpiAnswersOfManagerAndReviewerEvalutationSampleExcelFile.data = []
        state.downloadKraKpiAnswersOfManagerAndReviewerEvalutationSampleExcelFile.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(DOWNLOADKRAKPIANSWERSOFMANAGERANDREVIEWEREVALUTATIONSAMPLEEXCELFILE.fulfilled, (state, action) => {
      state.downloadKraKpiAnswersOfManagerAndReviewerEvalutationSampleExcelFile = {
        ...state.downloadKraKpiAnswersOfManagerAndReviewerEvalutationSampleExcelFile,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(DOWNLOADKRAKPIANSWERSOFMANAGERANDREVIEWEREVALUTATIONSAMPLEEXCELFILE.pending, (state, action) => {
      state.downloadKraKpiAnswersOfManagerAndReviewerEvalutationSampleExcelFile = {
        ...state.downloadKraKpiAnswersOfManagerAndReviewerEvalutationSampleExcelFile,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(DOWNLOADKRAKPIANSWERSOFMANAGERANDREVIEWEREVALUTATIONSAMPLEEXCELFILE.rejected, (state, action) => {
      state.downloadKraKpiAnswersOfManagerAndReviewerEvalutationSampleExcelFile = {
        ...state.downloadKraKpiAnswersOfManagerAndReviewerEvalutationSampleExcelFile,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const downloadKraKpiAnswersOfManagerAndReviewerEvalutationSampleExcelFileAction = {
    DOWNLOADKRAKPIANSWERSOFMANAGERANDREVIEWEREVALUTATIONSAMPLEEXCELFILE,
};

export { downloadKraKpiAnswersOfManagerAndReviewerEvalutationSampleExcelFileAction };
export default downloadKraKpiAnswersOfManagerAndReviewerEvalutationSampleExcelFileSlice.reducer;
export const {setInitialStateOfdownloadKraKpiAnswersOfManagerAndReviewerEvalutationSampleExcelFile} = downloadKraKpiAnswersOfManagerAndReviewerEvalutationSampleExcelFileSlice.actions
